var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.shouldPlanChange
    ? _c("plan-change", {
        attrs: {
          plan: _vm.plan,
          subscription: _vm.subscription,
          determinations: _vm.determinations,
          "is-current-plan": _vm.isCurrentPlan,
          discount: _vm.discount,
          "price-with-discount": _vm.priceWithDiscount,
          "color-set": _vm.colorSet,
        },
      })
    : _vm.subscription
    ? _c("subscription-status", {
        attrs: {
          plan: _vm.plan,
          subscription: _vm.subscription,
          determinations: _vm.determinations,
          "is-current-plan": _vm.isCurrentPlan,
          "allow-plan-actions": _vm.allowPlanActions,
          "color-set": _vm.colorSet,
        },
        on: {
          cancel: function ($event) {
            return _vm.$emit("cancel")
          },
          "setup-auto-renew": function ($event) {
            return _vm.$emit("setup-auto-renew")
          },
        },
      })
    : _vm.determinations.isBacker
    ? _c("pre-order-backer-status", {
        attrs: {
          plan: _vm.plan,
          subscription: _vm.subscription,
          determinations: _vm.determinations,
          "is-current-plan": _vm.isCurrentPlan,
          "allow-plan-actions": _vm.allowPlanActions,
          "pre-order-backer-dates": _vm.preOrderBackerDates,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }